import { render, staticRenderFns } from "./ProductsSelectList.vue?vue&type=template&id=25d4e10c&scoped=true&"
import script from "./ProductsSelectList.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSelectList.vue?vue&type=style&index=0&id=25d4e10c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d4e10c",
  null
  
)

export default component.exports